import i18next from 'i18next';
import {
  getInputSearchFilter,
  getMultiSelectSearchFilter,
} from '../../components';
import { accessRoute } from '../../routes/Dashboard';
import { accessRoute as priceManagementRoutes } from '../../routes/PriceManagement';
import { accessRoute as ncaAccessRoute } from '../../routes/AdminSetting';
import {
  checkValidData,
  getBooleanResponse,
  getServiceName,
  serialNumberFormatter,
} from '../../components/UIElements/Formatter';
import {
  getTupleStatusList,
  booleanYesNoList,
  YesNoList,
} from '../index.service';
import { generatePath } from 'react-router-dom';

export const serviceSubcategoryTableColumn = ({
  Action,
  Toggle,
  filter,
  onFilterChange,
  ViewButton,
  page,
  sizePerPage,
  isCategory = false,
}) => {
  return [
    {
      dataIndex: 'id',
      title: i18next.t('text.common.serialNo'),
      headerClasses: 'w_70',
      render: (cell, row, index) =>
        serialNumberFormatter({ page, sizePerPage, index }),
      exportFormatter: (cell, row, index) =>
        serialNumberFormatter({ page, sizePerPage, index }),
    },
    {
      dataIndex: 'name',
      title: i18next.t('text.common.name'),
      exportName: i18next.t('text.common.subCategory'),
      filterDataIndex: ['subCategory'],
      sorter: true,
      render: (cell, row) => checkValidData(cell),
      ...getInputSearchFilter({
        dataIndex: 'subCategory',
        placeholder: 'name',
        onFilterChange,
        filter,
      }),
    },
    ...[
      isCategory
        ? {
            dataIndex: 'name',
            title: i18next.t('text.common.category'),
            exportFormatter: (cell, row, index) => isCategory,
          }
        : {},
    ],
    {
      dataIndex: 'serviceType',
      title: i18next.t('text.manageServices.serviceType'),
      sorter: true,
      export: false,
      exportName: i18next.t('text.common.serviceTypeCount'),
      exportFormatter: (cell, row) => checkValidData(row?.subTypeCount),
      render: (cell, row) => {
        return <ViewButton row={row} cell={cell} />;
      },
    },
    {
      dataIndex: 'displayOrder',
      title: i18next.t('text.manageServices.displayOrder'),
      headerClasses: 'sorting',
      sorter: true,

      render: (cell, row) => checkValidData(cell),
    },
    {
      dataIndex: 'isSalesQuote',
      title: i18next.t('text.manageServices.salesQuote'),
      filterDataIndex: ['salesQuote'],
      sorter: true,
      export: false,
      render: (cell, row) => getBooleanResponse(cell),
      exportFormatter: (cell, row) => getBooleanResponse(cell),

      ...getMultiSelectSearchFilter({
        dataIndex: 'salesQuote',
        onFilterChange,
        name: 'sales quote',
        list: [],
        mode: false,
        listService: booleanYesNoList,
        filter,
      }),
    },
    {
      dataIndex: 'isCallingService',
      title: i18next.t('text.manageServices.callingServiceAmazonAlex'),
      filterDataIndex: ['serviceStatus'],
      sorter: true,
      export: false,
      render: (cell, row) => getServiceName(cell, row),
      exportFormatter: (cell, row) => getServiceName(cell, row),
      ...getMultiSelectSearchFilter({
        dataIndex: 'serviceStatus',
        onFilterChange,
        name: 'calling service',
        list: [],
        mode: false,
        filter,
        listService: YesNoList,
      }),
    },
    {
      dataIndex: 'isTechnicianTalkService',
      title: i18next.t('text.manageServices.talkServiceAmazonAlex'),
      filterDataIndex: ['talkToTechnicianService'],
      sorter: true,
      export: false,
      render: (cell, row) => getBooleanResponse(cell),
      exportFormatter: (cell, row) => getBooleanResponse(cell),
      ...getMultiSelectSearchFilter({
        dataIndex: 'talkToTechnicianService',
        onFilterChange,
        name: 'technician service',
        list: [],
        mode: false,
        filter,
        listService: YesNoList,
      }),
    },
    {
      dataIndex: 'status',
      title: i18next.t('text.localization.status'),
      headerClasses: 'sorting',
      sort: true,
      render: (cell, row) => {
        return <Toggle row={row} cell={cell} />;
      },
      ...getMultiSelectSearchFilter({
        dataIndex: 'status',
        onFilterChange,
        name: 'status',
        list: [],
        filter,
        mode: false,
        listService: getTupleStatusList,
      }),
    },
    {
      dataIndex: 'action',
      title: i18next.t('text.localization.action'),
      className: 'nk-tb-col-tools text-end',
      render: (cell, row) => {
        return <Action row={row} cell={cell} />;
      },
    },
  ];
};

export const breadcrumbServiceSubcategory = () => {
  return [
    {
      path: accessRoute.DASHBOARD.path,
      name: i18next.t('text.common.dashboard'),
    },
    {
      path: priceManagementRoutes.LIST_SERVICE_CATEGORY.path,
      name: i18next.t('text.manageServices.heading'),
    },
    {
      path: '#',
      name: i18next.t('text.manageServices.subServiceCategory'),
    },
  ];
};

export const addBreadcrumbServiceSubcategory = ({ id }) => {
  return [
    {
      path: accessRoute.DASHBOARD.path,
      name: i18next.t('text.common.dashboard'),
    },
    {
      path: generatePath(priceManagementRoutes.LIST_SUB_SERVICE_CATEGORY.path, {
        id,
      }),
      name: i18next.t('text.manageServices.subServiceCategory'),
    },
    {
      path: '#',
      name: i18next.t('text.manageServices.addSubCategory'),
    },
  ];
};

export const editBreadcrumbServiceSubcategory = ({ id }) => {
  return [
    {
      path: accessRoute.DASHBOARD.path,
      name: i18next.t('text.common.dashboard'),
    },
    {
      path: generatePath(priceManagementRoutes.LIST_SUB_SERVICE_CATEGORY.path, {
        id,
      }),
      name: i18next.t('text.manageServices.subServiceCategory'),
    },
    {
      path: '#',
      name: i18next.t('text.manageServices.editSubCategory'),
    },
  ];
};
// For NCA
export const breadcrumbServiceSubcategoryNCA = (url) => {
  return [
    {
      path: accessRoute.DASHBOARD.path,
      name: i18next.t('text.common.dashboard'),
    },
    {
      path: ncaAccessRoute.LIST_NCA.path,
      name: i18next.t('text.common.nca'),
    },
    {
      path: url,
      name: i18next.t('text.common.editNCA'),
    },
    {
      path: '#',
      name: i18next.t('text.manageServices.subServiceCategory'),
    },
  ];
};

export const addNCABreadcrumbServiceSubcategory = ({ url, ncaEditUrl }) => {
  return [
    {
      path: accessRoute.DASHBOARD.path,
      name: i18next.t('text.common.dashboard'),
    },
    {
      path: ncaAccessRoute.LIST_NCA.path,
      name: i18next.t('text.common.nca'),
    },
    {
      path: ncaEditUrl,
      name: i18next.t('text.common.editNCA'),
    },
    {
      path: url,
      name: i18next.t('text.manageServices.subServiceCategory'),
    },
    {
      path: '#',
      name: i18next.t('text.manageServices.addSubCategory'),
    },
  ];
};

export const editNCABreadcrumbServiceSubcategory = ({ ncaUrl, ncaEditUrl }) => {
  return [
    {
      path: accessRoute.DASHBOARD.path,
      name: i18next.t('text.common.dashboard'),
    },
    {
      path: ncaAccessRoute.LIST_NCA.path,
      name: i18next.t('text.common.nca'),
    },
    {
      path: ncaEditUrl,
      name: i18next.t('text.common.editNCA'),
    },
    {
      path: ncaUrl,
      name: i18next.t('text.manageServices.subServiceCategory'),
    },
    {
      path: '#',
      name: i18next.t('text.manageServices.editSubCategory'),
    },
  ];
};
